<template>
    <div class="login-page">
      <div class="admin-link">
        <a href="#" class="admin-text">代理端</a>
      </div>
      <div class="login-box">
        <div class="logo-section">
          <!-- 替换 src 为你的 logo 图片地址 -->
          <img class="logo-img" :src="require('@/assets/images/登录logo.png')" alt="logo" />
          <!-- <div class="logo-title">
            <div class="main-title">声瀚网络科技</div>
            <div class="sub-title">SHENGHAN NETWORK TECHNOLOGY</div>
          </div> -->
        </div>
        <el-form :model="loginForm" class="login-form">
          <el-form-item>
            <el-input
              prefix-icon="el-icon-user"
              v-model="loginForm.username"
              placeholder="请输入用户名"
              size="large"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              prefix-icon="el-icon-lock"
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              size="large"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="login-btn"
              type="primary"
              :loading="loading"
              @click="handleLogin"
              size="large"
              style="background: #C5ECFF; border: none; color: #fff;"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginPage',
    data() {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        loading: false
      }
    },
    methods: {
      async handleLogin() {
        this.loading = true;
        // 登录逻辑
        
        try {
          const res = await this.$axios.post('/auth/login', {
            username: this.loginForm.username,
            password: this.loginForm.password
          })

          localStorage.setItem('token', res.token)
          
          const userInfo = await this.$axios.post('/auth/getUserInfo')
          console.log(userInfo);
          // 是否过期
          if (userInfo.data.expire_time) {
            const now = new Date()
            const expire = new Date(userInfo.data.expire_time)

            if (now > expire) {
              localStorage.setItem('token', '')
              this.$router.push({name:'Title',query: {
                userInfo: JSON.stringify(userInfo.data)
              }})
            } else {
              localStorage.setItem('userInfo',JSON.stringify(userInfo.data))
              this.$router.push("/")
            }
          }

        } catch (err) {
          console.error(err)
          this.msg = err.response?.data?.msg || '登录失败'
          this.loading = false;
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .login-page {
    width: 100vw;
    height: 100vh;
    background: #fff;
    position: relative;
  }
  
  .admin-link {
    position: absolute;
    top: 20px;
    right: 40px;
  }
  
  .admin-text {
    color: #3BB2FF;
    font-size: 14px;
    text-decoration: none;
  }
  
  .login-box {
    width: 400px;
    margin: 0 auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 18%;
  }
  
  .logo-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
  }
  
  .logo-img {
    
    margin-right: 16px;
    object-fit: contain;
  }
  
  .logo-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .main-title {
    font-size: 38px;
    font-weight: bold;
    color: #222;
    letter-spacing: 2px;
    margin-bottom: 2px;
    font-family: '微软雅黑', 'Microsoft YaHei', Arial, sans-serif;
  }
  
  .sub-title {
    font-size: 16px;
    color: #222;
    letter-spacing: 2px;
    font-family: 'Roboto', Arial, sans-serif;
  }
  
  .login-form {
    margin-top: 10px;
  }
  
  .el-input__inner {
    background: #f8f8f8;
    border: none;
    height: 44px;
    font-size: 16px;
    color: #222;
  }
  
  .el-form-item {
    margin-bottom: 14px;
  }
  
  .login-btn {
    width: 100%;
    height: 40px;
    background: #C5ECFF !important;
    border-radius: 20px;
    color: #fff;
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: 600;
    border: none;
    transition: background .2s;
  }
  
  .login-btn:active,
  .login-btn:focus {
    background: #A2DBFF !important;
    color: #fff;
  }
  
  ::v-deep .el-input__prefix {
    color: #bdbdbd;
  }
  </style>